<template>
  <el-dialog title="审核" :visible.sync="shenheMark" :close-on-click-modal="false" width="90%" center
    :before-close="closeadd">
    <div class="dialog-table-wrapper">
      <el-table :data="tableDataList" ref="table" bordersize="mini" style="width: 100%" class="tableComent" highlight-current-row center border  :height="tableHeight" :key="tableKey">
        <el-table-column prop="incomeExpenseType" width="175" label="收支类型">
          <template slot-scope="scope">
              <span>{{ scope.row.incomeExpenseType == 0 ? '收款' : '付款' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="flowItemName" min-width="130" label="现金流项目"></el-table-column>
        <el-table-column prop="itemName" width="90" label="项目名称"></el-table-column>
         <el-table-column prop="debtAmount" width="98" label="总欠款(万元)"></el-table-column>
        <!-- <el-table-column prop="paymentCycle" width="90" label="收付款周期"></el-table-column> -->
        <el-table-column prop="supplierName" width="130" label="供应商"></el-table-column>
        <el-table-column prop="incomeExpenseType" width="90" label="收支方式">
          <template slot-scope="scope">
              <span>{{['现金' ,'承兑','现汇'][scope.row.paymentMethods]}}</span>
          </template>
        </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" width="100">
            <template slot-scope="scope">
              <div>
                <span v-if="!scope.row.isEditing">{{ scope.row.cycleAmounts[item.valueKey] }}</span>
                <el-input v-else v-model="scope.row.cycleAmounts[item.valueKey]" @input="handleCycleAmount(scope.row, item, $event)" v-number-input.float="4" placeholder="请输入" size="mini"></el-input>
              </div>
            </template>
          </el-table-column>
        </template>
         <el-table-column prop="incomeExpenseType" width="90" label="开票情况">
          <template slot-scope="scope">
              <span>{{ ['已开票' ,'款到发货','预付款'][scope.row.invoiceStatus] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="predictedAmount" width="140" label="预估收支合计(万元)"></el-table-column>
        <el-table-column prop="actualAmount" width="110" label="实际收支(万元)"></el-table-column>
        <el-table-column prop="remark" width="100" label="备注"></el-table-column>

      </el-table>
       <el-form  :inline="true"  ref="SHform" :model="BHform"  class="demo-form-inline"  label-width="80px"  size="mini"  style="margin-top: 20px;">
        <el-form-item label="审核备注" class="item1" prop="auditRemark">
          <el-input placeholder="" type="textarea" maxlength="100" v-model="SHform.auditRemark"  style="width: 500px;"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="closeadd">取 消</el-button>
      <el-button type="primary"   @click="tongguoFn">审核通过</el-button>
      <el-button type="primary"    @click="bohuiFn">审核驳回</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { weekDetailList, weeklyApprove, weeklyNotApprove } from '@/api/common-signature'
export default {
  name: 'monthPlanDialog',
  components: {},
  data () {
    return {
      tableDataList: [],
      tableHeadList: [],
      detailForm: {
        pageNo: 1,
        pageSize: 200,
        incomeExpenseType: ''
      },
      tableHeight: 500,
      SHform: {}
    }
  },
  props: {
    shenheMark: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.adjustTableHeight()
    })
    this.SHform.id = this.rowData.id
  },
  created () {
    this.detailList()
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.$refs.table) {
          this.$refs.table.doLayout()
        }
      }, 200)
    })
  },
  watch: {
    tableHeadList: {
      handler (newVal) {
        if (newVal && newVal.length > 0 && this.tableDataList.length > 0) {
        // 当表头变化时，确保每行数据都有对应的动态列值
          this.tableDataList.forEach(row => {
            if (!row.cycleAmounts) {
              row.cycleAmounts = {}
            }
            newVal.forEach(header => {
              if (row.cycleAmounts[header.valueKey] === undefined) {
                this.$set(row.cycleAmounts, header.valueKey, '')
              }
            })
          })
        }
        this.$nextTick(() => {
          this.adjustTableHeight()
        })
        this.$nextTick(() => {
          this.tableKey += 1
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    tongguoFn () {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      weeklyApprove(this.SHform).then(res => {
        this.closeadd()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    bohuiFn () {
      if (!this.SHform.auditRemark) {
        this.$message.error('请输入审核备注')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      weeklyNotApprove(this.SHform).then(res => {
        this.closeadd()
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        loading.close()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    adjustTableHeight () {
      // 基础高度
      let baseHeight = 600

      // 根据数据量调整
      const rowCount = this.tableDataList.length
      if (rowCount > 10) {
        baseHeight = 600
      }

      this.tableHeight = baseHeight
    },
    detailList () {
      this.$set(this.detailForm, 'weeklyPlanMasterId', this.rowData.id)
      weekDetailList(this.detailForm)
        .then(res => {
          console.log(res)
          this.tableHeadList = res.titleList || []
          if (res.pageInfo && res.pageInfo.list && res.pageInfo.list.length > 0) {
            // 处理数据，确保动态列的值正确绑定
            this.tableDataList = res.pageInfo.list.map(item => {
              // 确保 cycleAmounts 存在
              if (!item.cycleAmounts) {
                item.cycleAmounts = {}
              }

              // 将动态表头对应的值赋值给 cycleAmounts
              if (this.tableHeadList && this.tableHeadList.length > 0) {
                this.tableHeadList.forEach(header => {
                  // 如果返回的数据中有动态列的值，将其放入 cycleAmounts
                  if (item[header.valueKey] !== undefined) {
                    item.cycleAmounts[header.valueKey] = item[header.valueKey]
                  } else if (item.cycleAmounts[header.valueKey] === undefined) {
                    // 如果没有值，设置为空字符串
                    item.cycleAmounts[header.valueKey] = ''
                  }
                })
              }
              return item
            })
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
    },
    closeadd () {
      this.$parent.searchFn()
      this.$emit('update:shenheMark', false)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}
.dialog-table-wrapper {
  // 确保容器不会限制表格
  min-height: 300px;
  max-height: 700px;
  overflow: hidden;
}

// 确保表格滚动正常工作
::v-deep .el-table__body-wrapper {
  overflow-y: auto !important;
}
</style>
